import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--taxes--dashboard`
  }

  doTaxesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--financials--taxes--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--financials--taxes--create
                                                                                                     operations--products--clinics--financials--taxes--update
                                                                                                     operations--products--clinics--financials--taxes--show"></div>
                </div>`

    // this.getControllerByIdentifier("operations--products--clinics--financials--show--main").contentTarget.innerHTML = html
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--financials--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--financials--show--submenu`).dashboardToggleBtn(`IMPOSTOS`)

      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--index`).permission = `medclinic_financial_taxes`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--show`).permission = `medclinic_financial_taxes`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--create`).permission = `medclinic_financial_taxes`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--update`).permission = `medclinic_financial_taxes`

      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--financials--taxes--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
